import React from 'react';
import {
  CookbookSingleSelectSearchBase,
  CookbookSingleSelectSearchWrapperProps,
} from 'src/components/CookbookSingleSelectSearchBase/CookbookSingleSelectSearchBase';
import { useClientSelectSearch } from 'src/components/CookbookClientSelectSearchWrapper/useClientSelectSearch';

export type CookbookClientSelectSearchWrapperProps = Omit<
  CookbookSingleSelectSearchWrapperProps,
  'onSearchChange' | 'onSelect' | 'onCollapse'
>;

export function CookbookClientSelectSearchWrapper({
  options,
  ...props
}: CookbookClientSelectSearchWrapperProps): JSX.Element {
  const { displayedOptions, onSearchHandle, restoreOptions } =
    useClientSelectSearch({
      options,
    });

  return (
    <CookbookSingleSelectSearchBase
      {...props}
      options={displayedOptions}
      onCollapse={restoreOptions}
      onSearchChange={onSearchHandle}
      onSelect={restoreOptions}
    />
  );
}
